const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.superadmin_note_categories/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.superadmin_note_categories/LIST_NOTE_CATEGORIES_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    default:
      return state;
  }
}
